import * as React from 'react';
import { login, whoAmI } from '../../server/server';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../auth/UseUser';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { notif } from '../utils/util';
import Loading from '../../utils/Loading';
import { ReactComponent as ShowPasswordIcon } from '../../assets/svg/ShowPasswordIcon.svg';
import { ReactComponent as HidePasswordIcon } from '../../assets/svg/HidePasswordIcon.svg';

type Inputs = {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    city: string;
    member: string;
    community: string;
    rpgNumber: string;
    hidNumber: string;
    phoneNumber: string;
};
interface SignIn {
    setSelectedMode: any;
}

export default function SignIn({ setSelectedMode }: SignIn) {
    const navigate = useNavigate();
    const { setUser } = useUser();
    const [showPassword, setShowPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // navigate('/login');
        notif('Molim vas da se prijavite');
    }, []);

    const {
        register,
        handleSubmit,
        getValues,
        formState: { errors },
    } = useForm<Inputs>({
        defaultValues: {
            email: '',
            password: '', //email: 'zoranmarcetic@hotmail.com',
            //password: 'Lozinka2',
        },
    });

    const toggleShowPassword = () => {
        setShowPassword((prev) => !prev);
    };

    const onSubmit: SubmitHandler<Inputs> = async () => {
        loginUser();
    };

    const loginUser = async () => {
        setLoading(true);
        const resp = await login({
            email: getValues('email'),
            password: getValues('password'),
        });
        if (resp?.status === 201) {
            const data = resp.data;
            setErrorMessage('');
            localStorage.setItem('accessToken', data['accessToken']);
            const token = localStorage.getItem('accessToken');
            const response = await whoAmI();
            if (response.status === 200) {
                console.log('who am i success ', response.data);
                const user = response.data;
                if (user.valid === false) {
                    setErrorMessage('Vaš nalog nije verifikovan. Molimo vas proverite vas inbox');
                    setLoading(false);
                    localStorage.removeItem('accessToken');
                    return;
                }
                setUser(response.data);
                // localStorage.setItem('user', JSON.stringify(response.data));
                navigate('/');
            } else {
                console.log('who am i failed ', response.status);
            }
        } else {
            console.log('login error', resp?.data?.message);
            setErrorMessage(resp?.data?.message);
        }
        setLoading(false);
    };

    return (
        <div className="w-full bg-white flex flex-col items-center">
            <div className="flex flex-col max-w-[430px] w-full px-3 m-auto ">
                <p className="text-[32px] leading-[44px] text-grey-800  font-bold  ">Prijavite se</p>
                <p className="text-[16px] leading-5 text-grey-800 font-medium mt-[12px] mb-[32px] ">
                    Prijavite se na sistem unošenjem vaše email adrese i lozinke
                </p>
                <form className="flex flex-col items-center w-full " onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                    <div className="flex flex-col w-full">
                        <label className="text-[16px] leading-5 text-grey-800 font-bold  ">Email adresa</label>
                        <div className=" border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center ">
                            <input
                                className="text-[16px] leading-[22px] text-grey-800  w-full outline-none  placeholder:text-black200 "
                                placeholder="Email adresa"
                                {...register('email', {
                                    required: true,
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: 'invalid email address',
                                    },
                                })}
                            />
                        </div>
                        <span className="text-redError text-[12px] leading-5 h-5 ">
                            {errors.email?.type === 'required' ? 'Obavezno popunite ovo polje!' : ''}
                            {errors.email?.type === 'pattern' ? 'Email adresa nije ispravno popunjena!' : ''}
                        </span>
                    </div>
                    <div className="flex flex-col w-full">
                        <label className="text-[16px] leading-5 text-grey-800 font-bold  ">Lozinka</label>
                        <div className=" border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center ">
                            <input
                                className="text-[16px] leading-[22px] text-grey-800  w-full outline-none  placeholder:text-black200 "
                                placeholder="Lozinka"
                                type={showPassword ? 'text' : 'password'}
                                {...register('password', { required: true })}
                                autoComplete="off"
                                onClick={() => setErrorMessage('')}
                            />
                            <div className="cursor-pointer" onClick={toggleShowPassword}>
                                {!showPassword ? <ShowPasswordIcon /> : <HidePasswordIcon width={22} height={18} />}
                            </div>
                        </div>
                        <span className="text-redError text-[12px] leading-5 h-5 ">
                            {errors.password?.type === 'required' ? 'Obavezno popunite ovo polje!' : ''}
                        </span>
                    </div>
                    <div className="w-full flex flex-row items-center ">
                        <div
                            className="text-[16px] leading-[22px] text-grey-800 hover:text-grey-900 font-bold cursor-pointer"
                            onClick={() => setSelectedMode('forgotPassword')}
                        >
                            Zaboravljena lozinka
                        </div>
                    </div>

                    <p className="text-redError text-[12px] leading-5 min-h-[20px] mt-1 text-center">{!!errorMessage ? errorMessage : ''}</p>
                    <button
                        type="submit"
                        className="w-full h-[50px] flex items-center justify-center rounded-[4px] border-2 border-grey-300 hover:border-grey-700 bg-white text-[18px] text-grey-800 font-bold cursor-pointer mt-1"
                        disabled={loading}
                    >
                        {loading ? <Loading size={25} /> : 'Prijava'}
                    </button>
                </form>
                <p className=" text-[16px] text-grey-800 leading-5 font-semibold  text-center mt-10 ">Nemate nalog?</p>
                <button
                    type="button"
                    className="w-full h-[50px] flex items-center justify-center rounded-md  border-2 border-grey-300 hover:border-grey-700 bg-white text-[18px] text-grey-800 font-bold cursor-pointer mt-1 "
                    onClick={() => {
                        setSelectedMode('registration');
                    }}
                >
                    Registruj se
                </button>
            </div>
        </div>
    );
}
